/*
    Core store module mutations

*/

import * as temp from "./temp";
import * as user from "./user";

export default {
  ...temp,
  ...user
}
